"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateTeamsAppArguments = exports.ValidateTeamsAppOptions = void 0;
exports.ValidateTeamsAppOptions = [
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the Microsoft Teams app manifest template file path, it can be either absolute path or relative path to project root folder, defaults to './appPackage/manifest.json'",
        default: "./appPackage/manifest.json",
    },
    {
        name: "app-package-file",
        questionName: "app-package-file-path",
        type: "string",
        shortName: "p",
        description: "Specifies the zipped Microsoft Teams app package path, it's a relative path to project root folder, defaults to '${folder}/appPackage/build/appPackage.${env}.zip'",
    },
];
exports.ValidateTeamsAppArguments = [];
//# sourceMappingURL=ValidateTeamsAppOptions.js.map